'use strict';

function renderFilter (mustache, $marketingChecklist, categories) {
  var filterData = {};
  var key;
  var filterHtml;

  filterData.categories = [];

  for (key in categories) {
    filterData.categories.push({
      'id': key,
      'name': categories[key].name,
      'count': categories[key].count,
      'disabled': categories[key].count === 0 ? 'disabled' : undefined
    });
  }

  filterHtml = window.Mustache.render(
    mustache, filterData
  );

  $marketingChecklist
    .find('#marketing-checklist-filter .dropdown-menu')
    .prepend(filterHtml);
}

module.exports = renderFilter;
